export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION'
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS'
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION'

export const createNotification = (breakName, reminderType) => ({
  type: CREATE_NOTIFICATION,
  payload: { breakName, reminderType },
})

export const clearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS,
})

export const deleteNotification = payload => ({
  type: DELETE_NOTIFICATION,
  payload,
})



// WEBPACK FOOTER //
// ./src/modules/notification/actions.js